import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getAssessmentActivityFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`assessmentActivities.fields.Title`),
      columnHeader: t(`assessmentActivities.columns.Title`),
      allowAsConditionSource: true,
    },
    ActivityType: {
      fieldId: 'ActivityType',
      formLabel: t(`assessmentActivities.fields.ActivityType`),
      columnHeader: t(`assessmentActivities.columns.Type`),
      allowAsConditionSource: true,
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'assessmentActivities.type',
      },
    },
    Summary: {
      fieldId: 'Summary',
      formLabel: t(`assessmentActivities.fields.Summary`),
      columnHeader: t(`assessmentActivities.columns.Summary`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    Status: {
      fieldId: 'Status',
      formLabel: t(`assessmentActivities.fields.Status`),
      columnHeader: t(`assessmentActivities.columns.Status`),
      allowAsConditionSource: true,
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'assessmentActivities.status',
      },
    },
    AssignedUser: {
      fieldId: 'AssignedUser',
      formLabel: t(`assessmentActivities.fields.AssignedUser`),
      columnHeader: t(`assessmentActivities.columns.AssignedUser`),
      allowAsConditionSource: true,
      allowTargetConditions: true,
      displayType: {
        displayType: 'users',
        multiple: false,
      },
    },
    CompletionDate: {
      fieldId: 'CompletionDate',
      formLabel: t(`assessmentActivities.fields.CompletionDate`),
      columnHeader: t(`assessmentActivities.columns.CompletionDate`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t(`assessmentActivities.fields.NewFiles`),
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
